import React, { type ReactNode } from "react";

export type IRaangeLabelWithFAProps = Omit<IRaangeLabelProps, "fa">;

export interface IRaangeLabelProps {
  showsIcon?: boolean;
  fa: string;
  children?: ReactNode;
}

export const RaangeLabel = ({
  showsIcon = true,
  fa,
  children,
}: IRaangeLabelProps) => {
  return (
    <span className="raange-label">
      {showsIcon && <i className={`fas fa-${fa}`} />} {children}
    </span>
  );
};

/**
 * @deprecated
 */
export default RaangeLabel;
